import { execAdmin } from '@src/apis/reware/utils';

import type { RepairPriceCriteria, RepairPriceCriteriaTag } from './fetchRepairPricing';

export interface RepairPriceCriteriaUpdateInput {
  price?: number;
  rubricCode?: string | null;
  vendorCountryCode?: string | null;
  tags?: RepairPriceCriteriaTag[];
}

interface UpdateRepairPriceCriteriaVariables {
  partnerId: number;
  criteriaId: number;
  updates: RepairPriceCriteriaUpdateInput;
}

interface UpdateRepairPriceCriteriaResponse {
  partner?: {
    updateRepairPriceCriteria?: RepairPriceCriteria | null;
  };
}

export const updateRepairPriceCriteria = async (
  partnerId: number,
  criteriaId: number,
  updates: RepairPriceCriteriaUpdateInput,
): Promise<RepairPriceCriteria> => {
  const query = `
    mutation updateRepairPriceCriteria(
      $partnerId: Int!
      $criteriaId: Int!
      $updates: RepairPriceCriteriaUpdateInputAdmin!
    ) {
      partner(id: $partnerId) {
        updateRepairPriceCriteria(criteriaId: $criteriaId, updates: $updates) {
          id
          locationAttributeName
          problemAttributeName
          severityAttributeName
          price
          rubricCode
          vendorCountryCode
          tags { tag name }
        }
      }
    }
  `;

  const data = await execAdmin<UpdateRepairPriceCriteriaVariables, UpdateRepairPriceCriteriaResponse>(
    query,
    { variables: { partnerId, criteriaId, updates } },
  );

  const result = data.partner?.updateRepairPriceCriteria;
  if (!result) {
    throw new Error(
      `updateRepairPriceCriteria: unexpected response — partner.updateRepairPriceCriteria is ${result === null ? 'null' : 'undefined'}`
    );
  }
  return result;
};
